module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-left-top-stone-path-background.ef9b57b8.png";